import { webComponentsStyleTagTransform } from "@redotech/webpack-css-runtime/web-components";
import STYLE_MANAGER from "@redotech/redo-shopify-extension/style-manager";

export default webComponentsStyleTagTransform(STYLE_MANAGER);
